<template>
    <v-layout wrap>
        <v-flex xs12 class="d-flex align-center justify-space-between pb-0">
            <h2 class="text-h6">
                Sessões em andamento
                <span v-if="sortedSessions.length != sessions.length" class="text-subtitle-2 grey--text">{{ sortedSessions.length }} de {{ sessions.length }}</span>
            </h2>
            <RefreshTimer v-if="refresh" v-bind="refresh" />
        </v-flex>
        <v-flex xs12 v-if="sortedSessions.length == 0" class="text-center grey--text py-6">
            {{ sessions.length > 0 ? "Nenhuma sessão encontrada com os filtros" : "Nenhuma sessão em andamento" }}
        </v-flex>
        <v-flex v-for="session in sortedSessions" :key="session.id" xs12 sm6 md4 lg3 xl2>
            <SessionCard :session="session" @open-payment="$emit('open-payment', $event)" />
        </v-flex>
    </v-layout>
</template>

<script>
import RefreshTimer from "@/components/shared/RefreshTimer";
import SessionCard from "./SessionCard";
import { sessionPaymentAlerts } from "./shared/alerts";
import { matchSession } from "./shared/filters";

function critical(session) {
    return !!session.errorSession || sessionPaymentAlerts(session).some((a) => a.critical);
}

export default {
    name: "SessionsArea",

    components: { RefreshTimer, SessionCard },

    props: {
        sessions: { type: Array, required: true },
        filters: { type: Object, required: true },
        refresh: { type: Object, default: null },
    },

    computed: {
        sortedSessions() {
            // Sessões com erro ou problema crítico no pagamento sempre no topo para chamar atenção
            return this.sessions.filter((session) => matchSession(session, this.filters)).sort((a, b) => (critical(b) ? 1 : 0) - (critical(a) ? 1 : 0));
        },
    },
};
</script>
